module.exports = __webpack_public_path__ + "img/danger.b4b8dda2.png";